import { useTranslation } from "react-i18next";
import PopupDialog from "src/SharedComponents/PopupDialog/PopupDialog";
import AuraIcon from "src/images/AuraBlackIcon.png";
import Button from "src/Components/Button/Button";

type IUpgradeNonSuitePopup = {
    onClose: () => void;
}
const UpgradeNonSuitePopup:React.FC<IUpgradeNonSuitePopup> = ({onClose}) => {
    const { t } = useTranslation();
    
    return (
        <div>
            <PopupDialog onClose={() => onClose()} marginTop="100px" popupWidth="30%">
                <div className="p-3 pb-5" style={{marginLeft: '20px'}}>
                    <div className="row mt-5">
                        <img src={AuraIcon} alt="aura" style={{width: '64px', margin: 'auto'}}/>
                    </div>
                    <div className="row mt-4 text-center">
                        <span style={{fontWeight: '600', fontSize: '20px'}}>{t('LicenceUpgrade')}</span>
                    </div>
                    <div className="row mt-5 text-center">
                        <span style={{fontWeight: '400', fontSize: '14px'}}>
                            {t('LicenceModelChanged')}
                        </span>
                    </div>
                    <div className="row mt-3 text-center">
                        <span style={{fontWeight: '400', fontSize: '14px'}}>
                            {t('PleaseReachOut')}<a href={`mailto:${t('CustomerEmail')}`} className="ds-text-primary text-decoration-underline">{t('CustomerEmail')}</a>{t('ChangeAuraLicense')}
                        </span>
                    </div>
                    <div className="row mt-4 text-center">
                        <div>
                            <Button
                                height="48px"
                                width="120px"
                                backgroundColor="var(--primary-color)"
                                color="#fff"
                                fontWeight="500"
                                fontSize="14px"
                                text="Ok"
                                onClick={() => { onClose() }}
                            />
                        </div>
                    </div>
                </div>
            </PopupDialog>
        </div>
    )
}

export default UpgradeNonSuitePopup;